var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnsYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 6.50667C22.8679 6.02271 22.6103 5.58153 22.253 5.22694C21.8957 4.87235 21.4511 4.61669 20.9635 4.48534C19.174 4 11.9839 4 11.9839 4C11.9839 4 4.79371 4 3.0096 4.496C2.52197 4.62735 2.07741 4.88302 1.72013 5.23761C1.36285 5.5922 1.10525 6.03338 0.972899 6.51734C0.500003 8.29334 0.5 12 0.5 12C0.5 12 0.500018 15.7333 0.989036 17.4933C1.1204 17.9778 1.37765 18.4195 1.73509 18.7742C2.09252 19.129 2.53755 19.3843 3.02567 19.5147C4.80978 20 12 20 12 20C12 20 19.1902 20 20.9743 19.5147C21.4624 19.3843 21.9075 19.129 22.2649 18.7742C22.6223 18.4195 22.8796 17.9778 23.011 17.4933C23.5 15.7227 23.5 12 23.5 12C23.5 12 23.4838 8.288 23.0002 6.50667ZM9.69461 15.4293V8.56533L15.6595 11.9947L9.69461 15.4293Z",
    fill: "#A3B1CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsYoutube);
export default __webpack_public_path__ + "static/media/sns-youtube.f4659ea515482fd5678c15285abdb246.svg";
export { ForwardRef as ReactComponent };